import { useNavigate } from "react-router-dom";
import { PlanFeature } from "../../utils/utils";

const CalendarBloc=()=>{
    const navigate=useNavigate()
return(
    <div className="row px-80">
        <div className="col-md-4 d-flex flex-column justify-content-center">
            <h2 className="grey500">Attirez vos clients 
            sans effort</h2>
            <p className="body grey66 mt-16">Tirez parti de la visibilité de Twyny pour développer votre activité. 
                Fini la prospection, vos clients et leurs rendez-vous arrivent directement sur la plateforme.</p>
               <div className="mt-16"><PlanFeature text="Sans engagement"  />
                </div> 
                <div className="mt-16"><PlanFeature text="Accès illimité" /></div>
                <div className="mt-16"> <PlanFeature text="Frais de gestion compris" /></div>
                <button className=" twyny-cta-primary mt-32" onClick={()=>navigate('/registerPrestataire')}>
              Découvrir gratuitement
            </button>
        </div>
        <div className="col-md-1">

        </div>
        <div className="col-md-7">
        <img src="/images/Agendatwyny.png" alt="example calendar" className="w-100" />
        </div>
    </div>
)
}
export default CalendarBloc;